import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export default function CountrySelect({ value, onChange, placeholder = "Sélectionner un pays", testId = "country-select" }) {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    api.get("/countries").then((r) => setCountries(r.data)).catch(() => {});
  }, []);

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {countries.map((c) => (
          <SelectItem key={c.code} value={c.code} data-testid={`country-opt-${c.code}`}>
            <span className="mr-2">{c.flag}</span> {c.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
